"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function CheckpointCompletedBadgeMulticolor(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#495057",
    clipPath: "url(#prefix__checkpoint-completed-badge-multicolor__clip0_20282_5305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.145 8.803c.477-.937.022-1.737-.873-2.439-.368-.29-.36-.742.007-1.016.912-.684 1.215-1.49.881-2.551-.126-.401.16-.7.602-.808.137-.033.28-.066.419-.07.866-.016 1.39-.417 1.72-1.174.358-.812.749-.94 1.54-.483.784.45 1.464.417 2.234-.016.75-.424 1.147-.311 1.474.441.354.81.919 1.189 1.844 1.254.84.06 1.09.375.894 1.138-.225.87.004 1.497.728 2.072.633.502.633.92-.004 1.424-.729.577-.945 1.207-.727 2.075.192.756-.032 1.055-.846 1.119-.964.073-1.557.464-1.921 1.313-.3.696-.714.814-1.403.411-.805-.47-1.516-.483-2.327-.01-.715.415-1.125.295-1.437-.428-.36-.828-.938-1.219-1.885-1.282-.717-.047-.929-.303-.922-.968l.002-.002zm10.052-2.889c.05-2.373-1.993-4.357-4.54-4.412C5.058 1.446 2.94 3.357 2.89 5.804c-.05 2.385 2.024 4.38 4.595 4.425 2.544.043 4.661-1.897 4.712-4.315z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.798 12.115c1.528.502 2.747.15 3.658-1.053.56 1.13 1.11 2.236 1.703 3.428-.7-.116-1.31-.2-1.91-.325-.278-.057-.424.006-.553.235-.292.514-.608 1.013-.964 1.6l-1.934-3.883v-.002zM3.648 11.02c.425.662.63 1.386 1.446 1.623.807.235 1.406-.28 2.205-.554-.666 1.34-1.283 2.583-1.941 3.913-.336-.554-.642-1.033-.917-1.526-.152-.272-.314-.383-.667-.299-.565.133-1.145.2-1.843.315.587-1.184 1.132-2.287 1.717-3.47v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.431 4.835L6.789 8.143 4.655 6.204l.978-1.076 1.156 1.05 2.664-2.42.978 1.077z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__checkpoint-completed-badge-multicolor__clip0_20282_5305"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

CheckpointCompletedBadgeMulticolor.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
CheckpointCompletedBadgeMulticolor.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = CheckpointCompletedBadgeMulticolor;
exports["default"] = _default;